import { render, staticRenderFns } from "./CodeItemDetailPanel.vue?vue&type=template&id=7f087681&scoped=true"
import script from "./CodeItemDetailPanel.vue?vue&type=script&lang=js"
export * from "./CodeItemDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./CodeItemDetailPanel.vue?vue&type=style&index=0&id=7f087681&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f087681",
  null
  
)

export default component.exports